var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8604 25.6387C25.4602 25.5193 25.8156 24.8911 25.5301 24.3501C24.6395 22.6622 23.1439 21.1787 21.1931 20.0665C18.8426 18.7264 15.9627 18 13 18C10.0373 18 7.1574 18.7264 4.80693 20.0665C2.85609 21.1787 1.36045 22.6621 0.469855 24.3501C0.184435 24.8911 0.539761 25.5193 1.13964 25.6387L5.18961 26.445C10.3459 27.4716 15.6541 27.4716 20.8104 26.445L24.8604 25.6387Z",
    fill: "#479BD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 7.5C21 11.6421 17.6421 15 13.5 15C9.35786 15 6 11.6421 6 7.5C6 3.35786 9.35786 0 13.5 0C17.6421 0 21 3.35786 21 7.5Z",
    fill: "#479BD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFill);
export default __webpack_public_path__ + "static/media/User_fill.73ec9bfdd495a3b66d379e59bf920eb7.svg";
export { ForwardRef as ReactComponent };